import React from 'react'
import Close from '@material-ui/icons/Close'

export default function CloseIcon(props) {
    const { ...other } = props

    return (
        <Close { ...other }  />
    )
}